export const AB_TEST_SET_VALUE = 'AB_TEST_SET_VALUE' as const;

type SetABTestValueParams = {
  key: string;
  value: string;
};

export function setABTestValue({ key, value }: SetABTestValueParams) {
  return {
    type: AB_TEST_SET_VALUE,
    payload: { key, value },
  } as const;
}

export type AbTestAction = ReturnType<typeof setABTestValue>;
